"use strict";

import _ from "lodash";
import React from "react";
import { Link } from "react-router";
import moment from "moment";

class Upcoming_Event extends React.Component {
  constructor(props) {
    super(props);
    /* 
    this.state = {
      filter: this.props.pagetype ? this.props.pagetype : 'conference'
    };
    */
  }

  renderFormattedDate = (epochDate, format) => {
    let fmt = format ? format : "MMM. D, YYYY";
    return moment
        .unix(epochDate)
        .utcOffset("+0500")
        .format(fmt);
  }

  renderDate = (city, format, isMultiCity) => {
    let fmt = format ? format : "MMM. D, YYYY";
    if (!city)
      return moment
        .unix(city.date)
        .utcOffset("+0500")
        .format(fmt);

    return !format && city.end && city.start !== city.end
      ? [
          [
            moment
              .unix(city.start)
              .utcOffset("+0500")
              .format("MMM. D"),
            moment
              .unix(city.end)
              .utcOffset("+0500")
              .format("D, YYYY")
          ].join("-"), city.city
        ].join((isMultiCity ? ", " : " • "))
      : [
          moment
            .unix(city.start)
            .utcOffset("+0500")
            .format(fmt), city.city
        ].join((isMultiCity ? ", " : " • "));
  };

  render() {
    let eventLink = this.props.event.name
      ? "/conference/" +
        this.props.event.conference_id +
        "/" +
        this.props.event.year
      : this.props.event.link;

    let marketingImg = this.props.event.marketing_img
      ? "/" + this.props.event.marketing_img
      : null;
    
    let webinarImg = this.props.event.sponsor_logo
      ? "https://admin.pionline.com/" + this.props.event.sponsor_logo
      : null;

    let summaryDesc = this.props.event.summary
      ? this.props.event.summary
      : this.props.event.description;
    
    let webinardate = this.props.eventType == 'webinar' ?
      this.renderFormattedDate(this.props.event.date, "MMM. D, YYYY")
      : null;
   

    return (
      <div className="wrap-two">
        <div className="event-bio clearfix">
          <div className="event-info">

            {webinardate ? (
              <span>{webinardate}{ this.props.event.time ? ' • ' + this.props.event.time : null}</span>
            ) : null}
          
            {_.size(this.props.event.cities) > 1 ? (
               _.map(this.props.event.cities, (city, k) => {
                  return <span key={city.city}>
                    {city.on_demand ? "On Demand" : city.tbd ? "TBD" : this.renderDate(city, '', true) }
                    <span>{ k < this.props.event.cities.length - 1 ? ' • ' : null }</span>
                  </span>
                })
            ) : (
              _.map(this.props.event.cities, city => {
                return <span key={city._id}>{city.on_demand ? "On Demand" : city.tbd ? "TBD" : this.renderDate(city)}</span>;
              })
            )}

            {eventLink ? (
              <h4>
                <a href={eventLink}>
                  {this.props.event.name
                    ? this.props.event.name
                    : this.props.event.title}
                </a>
              </h4>
            ) : null}

            {!summaryDesc ? null : (
              <p
                itemProp="description"
                dangerouslySetInnerHTML={{ __html: summaryDesc }}
              />
            )}
          </div>
          <div className="event-dates">
            <ul>
              {_.map(this.props.event.cities, city => {
                return (
                  <li key={city._id}>
                    <Link
                      to={eventLink + "/agenda/" + city.city}
                      className="location"
                      key={city._id}
                    >
                      <time itemProp="startDate">
                        {city.on_demand ? "On Demand" : city.tbd ? "TBD" : this.renderDate(city)}
                      </time>
                      <i className="fa fa-angle-right" />
                    </Link>
                  </li>
                );
              })}
            </ul>

            {webinarImg ? (
              <div><img className="webinarImage" src={webinarImg}/></div>
            ) : null}

          </div>
        </div>
      </div>
    );
  }
}

export default Upcoming_Event;
